import * as React from "react";
import { v4 as uuidv4 } from "uuid";
import { CpArrayObject } from "../../gvc/testNewForm/CpArrayObject";
import { CpArrayItemNameValuePair } from "./CpArrayItemNameValuePair";

interface Props {
  index: number;
}
export const RuleHeaders: React.FC<Props> = ({ index }) => {
  return (
    <>
      <div className="mt-4 px-4 py-2 border rounded" style={{ maxWidth: 900 }}>
        <CpArrayObject
          factoryFn={() => ({ id: uuidv4(), name: "", value: "" })}
          name={`sidecar.envoy.jwt.rules.${index}.headers`}
          labels={["Name", "Value"]}
          label="Headers"
        >
          <CpArrayItemNameValuePair />
        </CpArrayObject>
      </div>
    </>
  );
};
